<template>
    <div class="el-button-group">
        <slot></slot>
    </div>
</template>
<script>
    export default {
        name: 'ElButtonGroup'
    };
</script>



// WEBPACK FOOTER //
// src/components/button/src/button-group.vue